module.exports = __webpack_public_path__ + "img/mv_heading_pc.d9349d4c.png";